import React from 'react';

//types
import { IIconRotatableProps } from 'assets/icons/IconProps';

export const DoubleDivider = ({
  width = 26,
  height = 26,
  stroke = '#82878c',
  strokeWidth = 2,
}: IIconRotatableProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 26 26"
  >
    <path
      d="M6 15.5H20"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 10.5H20"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
